// mermaid.js
import mermaid from 'mermaid';
import { nextTick } from 'vue';

export default {
  mounted(el, binding) {
    nextTick(() => {
      // todo el itself can be mermaid - check ?
      const mermaidElements = el.querySelectorAll('.mermaid');
      mermaidElements.forEach((element) => {
        try {
          mermaid.init(undefined, element);
          console.log('Mermaid diagram rendered - mounted!');
        } catch (error) {
          console.error('Mermaid diagram failed to render:', error);
          //el.innerHTML = '';
        }
      });
    });
  },
  updated(el, binding) {
    nextTick(() => {
      // todo el itself can be mermaid - check ?
      const mermaidElements = el.querySelectorAll('.mermaid');
      mermaidElements.forEach((element) => {
        try {
          mermaid.init(undefined, element);
          console.log('Mermaid diagram rendered - updated!');
        } catch (error) {
          console.error('Mermaid diagram failed to update:', error);
          //el.innerHTML = '';
        }
      });
    });
  },
};
